
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.btn {
  display:flex;
  cursor:pointer;
  align-items:center;
  border-radius:10px;
  border-width:0px;
  font-weight:var(--fw-semibold);
  line-height:1.25;
  text-decoration-line:none;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
  min-width:44px;
}
  .btn:focus{
    outline-width:1px;
    outline-style:dashed;
    outline-offset:4px;
  }
  .btn:not(.cta-dark, .cta-light) {
  background-color:var(--bh-neutral-light);
}
  .btn:not(.cta-dark, .cta-light) {
  color:var(--bh-neutral-white);
}
  .btn:not(.cta-dark, .cta-light):hover, .btn:not(.cta-dark, .cta-light):focus {
  background-color:var(--bh-neutral-default);
}
  .btn:not(.cta-dark, .cta-light):focus {
  outline-color:var(--bh-neutral-default);
}

.btn.parent-container-fit {
  display:flex;
  height:100%;
  width:100%;
  justify-content:center;
}

.btn.parent-container-fit .left, .btn.parent-container-fit .right {
  margin-bottom:0px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  padding-top:0px;
}

.btn.parent-container-fit.justify-between{
  justify-content:space-between;
}

.btn ghs-icon {
  position:relative;
  margin-left:0.5rem;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
}

.btn.chip {
  border-radius:0.375rem;
  border-width:1px;
  border-style:solid;
  font-weight:var(--fw-normal);
}

.btn.chip .right ghs-icon {
  margin-left:0px;
}

.btn.chip:focus {
  outline-style:solid;
}

.btn.chip:focus {
  outline-width:2px;
}

.btn.chip.small {
  height:30px;
}

.btn.chip.small {
  padding-left:0.375rem;
  padding-right:0.375rem;
}

.btn.chip.small {
  padding-top:0.25rem;
  padding-bottom:0.25rem;
}

.btn.chip.small .right {
  padding-left:0.5rem;
}

.btn.chip.medium {
  height:37px;
}

.btn.chip.medium {
  padding-left:0.5rem;
  padding-right:0.5rem;
}

.btn.chip.medium .right {
  padding-left:0.625rem;
}

.btn.chip.large {
  height:43px;
}

.btn.chip.large {
  padding-left:1rem;
  padding-right:1rem;
}

.btn.chip.large .right {
  padding-left:0.75rem;
}

.btn.none {
  display:flex;
  align-items:center;
  padding-left:1rem;
  padding-right:1rem;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.left {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
}

.top {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
  padding-bottom:0.5rem;
}

.right {
  display:flex;
  height:100%;
  align-items:center;
  padding-left:0.5rem;
}

.btn[aria-disabled='true'] {
  pointer-events:none !important;
  cursor:not-allowed !important;
  background-color:var(--neutral-gray-4) !important;
  color:var(--neutral-gray-1) !important;
}

.btn.small {
  max-height:45px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.medium {
  max-height:55px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.large {
  min-height:45px;
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

@media (min-width: 768px) {
  .btn.large {
    min-height:max-content;
  }
  .btn.large {
    padding-left:2rem;
    padding-right:2rem;
  }
  .btn.large {
    padding-top:1rem;
    padding-bottom:1rem;
  }
  .btn.large {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
  }
}

.btn.xl {
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  font-weight:var(--fw-light);
}

@media (min-width: 768px) {
  .btn.xl {
    min-height:max-content;
  }
  .btn.xl {
    padding-left:2rem;
    padding-right:2rem;
  }
  .btn.xl {
    padding-top:1rem;
    padding-bottom:1rem;
  }
  .btn.xl {
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
  }
}

.btn.cta-dark.small, .btn.cta-light.small, .btn.cta-dark.large, .btn.cta-light.large {
  padding:0px;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  min-height:auto;
}

.btn:has(> .top) {
  flex-direction:column;
  align-items:center;
  text-align:center;
}

[site='GHS'] .btn, :host([site='GHS']) .btn {
  font-family:var(--ff-display);
}

[site='GHS'] .btn.primary, [site='GHS'] .btn.secondary, [site='GHS'] .btn.tertiary, [site='GHS'] .btn.quaternary, :host([site='GHS']) .btn.primary, :host([site='GHS']) .btn.secondary, :host([site='GHS']) .btn.tertiary, :host([site='GHS']) .btn.quaternary {
  transition-property:box-shadow;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.tertiary:hover, [site='GHS'] .btn.quaternary:hover, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.tertiary:hover, :host([site='GHS']) .btn.quaternary:hover{
      box-shadow:var(--brand-shadow-sm);
    }

[site='GHS'] .btn.primary, :host([site='GHS']) .btn.primary {
  background-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.primary, :host([site='GHS']) .btn.primary {
  color:var(--neutral-white);
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.primary:focus {
  background-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.primary:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.secondary, :host([site='GHS']) .btn.secondary {
  background-color:var(--primary-green);
}

[site='GHS'] .btn.secondary, :host([site='GHS']) .btn.secondary {
  color:var(--neutral-white);
}

[site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.secondary:focus {
  background-color:var(--primary-green);
}

[site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.secondary:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:focus {
  outline-color:var(--primary-green);
}

[site='GHS'] .btn.tertiary, :host([site='GHS']) .btn.tertiary {
  background-color:var(--neutral-white);
}

[site='GHS'] .btn.tertiary, :host([site='GHS']) .btn.tertiary {
  color:var(--primary-blue);
}

[site='GHS'] .btn.tertiary:focus, :host([site='GHS']) .btn.tertiary:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  text-align:left;
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  text-decoration-line:underline;
}

[site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  text-align:left;
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  color:var(--neutral-white);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  text-decoration-line:underline;
}

[site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary, :host([site='GHS']) .btn.quaternary {
  background-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-white:focus, :host([site='GHS']) .btn.quaternary.border-white:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  color:var(--primary-blue);
}

[site='GHS'] .btn.quaternary.border-blue:focus, :host([site='GHS']) .btn.quaternary.border-blue:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-magenta:focus, :host([site='GHS']) .btn.quaternary.border-magenta:focus {
  outline-color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-color:var(--primary-green);
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  color:var(--primary-green);
}

[site='GHS'] .btn.quaternary.border-green:focus, :host([site='GHS']) .btn.quaternary.border-green:focus {
  outline-color:var(--primary-green);
}

[site='GHS'] .btn.tertiary.text-white, :host([site='GHS']) .btn.tertiary.text-white {
  color:var(--neutral-white);
}

[site='GHS'] .btn.tertiary.text-blue, :host([site='GHS']) .btn.tertiary.text-blue {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.tertiary.text-magenta, :host([site='GHS']) .btn.tertiary.text-magenta {
  color:var(--tertiary-magenta);
}

[site='GHS'] .btn.tertiary.text-green, :host([site='GHS']) .btn.tertiary.text-green {
  color:var(--primary-green);
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  min-height:6.5rem;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-radius:0px;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-width:2px;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-style:solid;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-color:var(--neutral-white);
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  background-color:var(--primary-blue);
}

@media (min-width: 768px) {
  [site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
    min-height:7.5rem;
  }
}

[site='GHS'] .btn.primary.border-square:hover, :host([site='GHS']) .btn.primary.border-square:hover {
  text-decoration-line:underline;
}

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, [site='BH'] .btn.chip, [site='BH'] .btn.emplify, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light, :host([site='BH']) .btn.chip, :host([site='BH']) .btn.emplify {
  font-family:var(--bh-ff-body);
}

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, [site='BH'] .btn.chip, [site='BH'] .btn.emplify, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light, :host([site='BH']) .btn.chip, :host([site='BH']) .btn.emplify {
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
}

[site='BH'] .btn.primary.xl, [site='BH'] .btn.secondary.xl, [site='BH'] .btn.tertiary.xl, [site='BH'] .btn.quaternary.xl, [site='BH'] .btn.cta-dark.xl, [site='BH'] .btn.cta-light.xl, [site='BH'] .btn.chip.xl, [site='BH'] .btn.emplify.xl, :host([site='BH']) .btn.primary.xl, :host([site='BH']) .btn.secondary.xl, :host([site='BH']) .btn.tertiary.xl, :host([site='BH']) .btn.quaternary.xl, :host([site='BH']) .btn.cta-dark.xl, :host([site='BH']) .btn.cta-light.xl, :host([site='BH']) .btn.chip.xl, :host([site='BH']) .btn.emplify.xl {
  font-weight:var(--fw-light);
}

[site='BH'] .btn.primary.xl, [site='BH'] .btn.secondary.xl, [site='BH'] .btn.tertiary.xl, [site='BH'] .btn.quaternary.xl, [site='BH'] .btn.cta-dark.xl, [site='BH'] .btn.cta-light.xl, [site='BH'] .btn.chip.xl, [site='BH'] .btn.emplify.xl, :host([site='BH']) .btn.primary.xl, :host([site='BH']) .btn.secondary.xl, :host([site='BH']) .btn.tertiary.xl, :host([site='BH']) .btn.quaternary.xl, :host([site='BH']) .btn.cta-dark.xl, :host([site='BH']) .btn.cta-light.xl, :host([site='BH']) .btn.chip.xl, :host([site='BH']) .btn.emplify.xl{
      font-size:clamp(1.5rem, calc(0rem + 3.13vw), 2rem);
      line-height:110%;
      letter-spacing:-0.16px;
    }

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light {
  font-weight:var(--fw-bold);
}

[site='BH'] .btn.primary, :host([site='BH']) .btn.primary {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.primary, :host([site='BH']) .btn.primary {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.primary:hover, [site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:hover, :host([site='BH']) .btn.primary:focus {
  background-color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-style:solid;
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-width:2px;
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.primary:active, :host([site='BH']) .btn.primary:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.primary:active, :host([site='BH']) .btn.primary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.primary[aria-disabled='true'], :host([site='BH']) .btn.primary[aria-disabled='true'] {
  background-color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.primary[aria-disabled='true'], :host([site='BH']) .btn.primary[aria-disabled='true'] {
  color:var(--bh-neutral-white) !important;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-width:2px;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-style:solid;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:hover, [site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:hover, :host([site='BH']) .btn.secondary:focus {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:hover, [site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:hover, :host([site='BH']) .btn.secondary:focus {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-style:solid;
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-width:2px;
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:active, :host([site='BH']) .btn.secondary:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:active, :host([site='BH']) .btn.secondary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  border-color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.tertiary, :host([site='BH']) .btn.tertiary {
  background-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary, :host([site='BH']) .btn.tertiary {
  color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.tertiary:hover, [site='BH'] .btn.tertiary:focus, [site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:hover, :host([site='BH']) .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:active {
  color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.tertiary:hover, :host([site='BH']) .btn.tertiary:hover {
  background-color:var(--bh-brand-primary-lighter);
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-style:solid;
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-width:2px;
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:active {
  background-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.tertiary[aria-disabled='true'], :host([site='BH']) .btn.tertiary[aria-disabled='true'] {
  background-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.tertiary[aria-disabled='true'], :host([site='BH']) .btn.tertiary[aria-disabled='true'] {
  color:var(--bh-neutral-darker) !important;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-width:2px;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-style:solid;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-style:solid;
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-width:2px;
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary:hover, [site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:hover, :host([site='BH']) .btn.quaternary:active {
  border-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.quaternary:hover, [site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:hover, :host([site='BH']) .btn.quaternary:active {
  background-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  border-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.cta-dark, :host([site='BH']) .btn.cta-dark {
  color:var(--bh-brand-primary-default-compatibility);
}

[site='BH'] .btn.cta-dark:hover, [site='BH'] .btn.cta-dark:active, [site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:hover, :host([site='BH']) .btn.cta-dark:active, :host([site='BH']) .btn.cta-dark:focus {
  color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.cta-dark:hover, [site='BH'] .btn.cta-dark:active, [site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:hover, :host([site='BH']) .btn.cta-dark:active, :host([site='BH']) .btn.cta-dark:focus {
  text-decoration-line:underline;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-style:solid;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-width:2px;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.cta-dark[aria-disabled='true'], :host([site='BH']) .btn.cta-dark[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.cta-dark[aria-disabled='true'], :host([site='BH']) .btn.cta-dark[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.cta-light, :host([site='BH']) .btn.cta-light {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.cta-light:hover, [site='BH'] .btn.cta-light:active, [site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:hover, :host([site='BH']) .btn.cta-light:active, :host([site='BH']) .btn.cta-light:focus {
  text-decoration-line:underline;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-style:solid;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-width:2px;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.cta-light[aria-disabled='true'], :host([site='BH']) .btn.cta-light[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.cta-light[aria-disabled='true'], :host([site='BH']) .btn.cta-light[aria-disabled='true'] {
  color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  border-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  color:var(--bh-neutral-darker);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  border-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.chip:focus, :host([site='BH']) .btn.chip:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:active, :host([site='BH']) .btn.chip:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:active, :host([site='BH']) .btn.chip:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  border-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  background-color:var(--bh-neutral-lighter) !important;
}

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.emplify, :host([site='BH']) .btn.emplify, [site='GHS'] .btn.emplify, :host([site='GHS']) .btn.emplify {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify, :host([site='BH']) .btn.emplify, [site='GHS'] .btn.emplify, :host([site='GHS']) .btn.emplify {
  background-color:var(--eh-brand-secondary-100);
}

[site='BH'] .btn.emplify:hover, [site='BH'] .btn.emplify:focus, :host([site='BH']) .btn.emplify:hover, :host([site='BH']) .btn.emplify:focus, [site='GHS'] .btn.emplify:hover, [site='GHS'] .btn.emplify:focus, :host([site='GHS']) .btn.emplify:hover, :host([site='GHS']) .btn.emplify:focus {
  background-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify:hover,
    [site='BH'] .btn.emplify:focus,
    :host([site='BH']) .btn.emplify:hover,
    :host([site='BH']) .btn.emplify:focus,
    [site='GHS'] .btn.emplify:hover,
    [site='GHS'] .btn.emplify:focus,
    :host([site='GHS']) .btn.emplify:hover,
    :host([site='GHS']) .btn.emplify:focus{
      color:#fff;
    }

[site='BH'] .btn.emplify:focus, :host([site='BH']) .btn.emplify:focus, [site='GHS'] .btn.emplify:focus, :host([site='GHS']) .btn.emplify:focus {
  outline-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify .right:has(> .extra-icon), :host([site='BH']) .btn.emplify .right:has(> .extra-icon), [site='GHS'] .btn.emplify .right:has(> .extra-icon), :host([site='GHS']) .btn.emplify .right:has(> .extra-icon) {
  padding-left:0px;
}

[site='BH'] .btn.emplify .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplify .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplify .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplify .right:has(> .extra-icon) .extra-icon {
  margin-left:0.25rem;
}

@media (min-width: 1024px){
      [site='BH'] .btn.emplify.small, :host([site='BH']) .btn.emplify.small, [site='GHS'] .btn.emplify.small, :host([site='GHS']) .btn.emplify.small {
    margin-top:0.375rem;
    margin-bottom:0.375rem;
  }
    }

:host{
  display:inline-flex;
  font-family:var(--ff-display);
}

:host .btn {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

@media (min-width: 768px) {
  :host .btn {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
  }
}

:host .btn.cta-dark, :host .btn.cta-light {
  padding:0px;
}

:host([container-fit-variant]), :host([container-fit-variant='true']) {
  height:100%;
  max-height:100vh;
  width:100%;
  max-width:none;
}

:host([container-fit-variant]) a, :host([container-fit-variant='true']) a {
  height:100%;
}

:host([container-fit-variant]) a, :host([container-fit-variant='true']) a {
  max-height:100vh;
}

:host([container-fit-variant]) a, :host([container-fit-variant='true']) a {
  width:100%;
}

:host([container-fit-variant]) a, :host([container-fit-variant='true']) a {
  max-width:none;
}

:host([container-fit-variant]):host([icon-position='top']), :host([container-fit-variant='true']):host([icon-position='top']) {
  display:inline-block;
}

:host([container-fit-variant]):host([icon-position='top']), :host([container-fit-variant='true']):host([icon-position='top']) {
  width:50%;
}

@media (min-width: 768px) {
  :host([container-fit-variant]):host([icon-position='top']), :host([container-fit-variant='true']):host([icon-position='top']) {
    width:25%;
  }
}

:host([animate-icon]) ghs-icon {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

:host([animate-icon]) ghs-icon {
  transition-duration:300ms;
}

:host([animate-icon]) .btn:hover .left ghs-icon, :host([animate-icon]) .btn:focus .left ghs-icon{
      transform:translateX(-40%);
    }

:host([animate-icon]) .btn:hover .right ghs-icon, :host([animate-icon]) .btn:focus .right ghs-icon{
      transform:translateX(40%);
    }

:host([animate-icon]) .btn.chip.small:hover .left ghs-icon, :host([animate-icon]) .btn.chip.small:focus .left ghs-icon, :host([animate-icon]) .btn.chip.medium:hover .left ghs-icon, :host([animate-icon]) .btn.chip.medium:focus .left ghs-icon{
        transform:translateX(-20%);
      }

:host([animate-icon]) .btn.chip.small:hover .right ghs-icon, :host([animate-icon]) .btn.chip.small:focus .right ghs-icon, :host([animate-icon]) .btn.chip.medium:hover .right ghs-icon, :host([animate-icon]) .btn.chip.medium:focus .right ghs-icon{
        transform:translateX(20%);
      }

:host([is-hovered='true']) .btn.cta-dark, :host([is-hovered='true']) .btn.cta-dark ghs-icon {
  color:var(--primary-blue-dark);
}

:host([is-hovered='true']) ghs-icon{
    transform:translateX(40%);
  }
`;